/* unplugin-vue-components disabled */
import BuilderInputs from 'components/builder/builder-inputs.vue'
import {makeAgentsSchema} from '../settings-defs'

export default {
  components: {
    BuilderInputs
  },
  provide() {
    return {
      store: this.all_agents,
    }
  },
  data() {
    return {
      all_agents: {
        external_sources: ['donik.com']
      },
      schema: makeAgentsSchema(),
      saved_at: undefined,
      saving: false,
      update: $utils.timers.debounce(this.onUpdate, 300)
    }
  },
  beforeUnmount() {
    this.update.abort()
  },
  methods: {
    async onUpdate() {
      this.saving = true
      await $utils.timers.wait(1000)
      this.saved_at = Date.now()
      this.saving = false
    }
  }
}
